<template>
  <v-container fluid>
    <v-tabs
      :key="tabRender"
      class="a-tabs pb-2"
      show-arrows
      height="38"
      style="background-color: var(--v-Neutral-base)"
      right
      v-model="roleTabIndex"
      @change="onTabChange"
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab class="ml-2"> {{ $t("admin.lblGeneralRoles") }} </v-tab>
      <v-tab> {{ $t("admin.lblMeetingBasedRoles") }} </v-tab>
    </v-tabs>
    <v-card raised style="width: 100%">
      <v-card-text>
        <v-row v-resize="onResize">
          <ejs-splitter
            id="splitter"
            ref="splitterObj"
            :separatorSize="3"
            class="splitterContent"
            width="100%"
          >
            <e-panes>
              <e-pane
                size="35%"
                :collapsible="false"
                :collapsed="false"
                content="#role-list-content"
                min="20%"
                cssClass="list-pane"
              ></e-pane>
              <e-pane
                cssClass="overflow-y-hidden table-pane"
                size="65%"
                min="50%"
                content="#role-permission-content"
              ></e-pane>
            </e-panes>
          </ejs-splitter>
          <v-card id="role-list-content" flat>
            <v-toolbar color="neutralGray" dark height="56px" flat tile>
              <v-icon size="26" class="mr-4">mdi-text-account</v-icon>
              <span style="margin-left: 5px" class="text-h6">{{
                roleTabIndex === 0
                  ? $t("admin.lblGeneralRoles")
                  : $t("admin.lblMeetingBasedRoles")
              }}</span>
            </v-toolbar>
            <v-card-title
              class="paler-bg"
              style="
                background-color: var(--v-appBar-base);
                border-bottom: solid 1px var(--v-appBar-darken2);
              "
            >
              <a-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                :label="$t('lblSearch')"
                single-line
                hide-details
                dense
                clearable
              ></a-text-field>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="ml-2"
                    color="primaryDark"
                    dark
                    x-small
                    right
                    fab
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="openRoleSetupDialog(false)"
                  >
                    <v-icon size="21">mdi-playlist-plus</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("admin.addRole") }}</span>
              </v-tooltip>
              <add-roles
                v-if="dialog"
                v-model="dialog"
                :data="roleForm"
                @saveRoles="onSuccess"
                :permissionsList="permissionsList"
                :formData="formData"
              />
            </v-card-title>
            <v-divider></v-divider>
            <roles-list
              v-model="selectedRoleId"
              :roles-list="filteredItems"
              :screenHeight="screenHeight"
            ></roles-list>
          </v-card>
          <v-card id="role-permission-content" style="text-align: left" flat>
            <v-toolbar color="secondary" height="56px" flat tile>
              <v-icon size="26">mdi-application-cog</v-icon>
              <span style="margin-left: 5px" class="text-h6">{{
                $t("admin.rolePermissions")
              }}</span>
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <a-btn
                    v-bind="attrs"
                    v-on="on"
                    color="primaryDark"
                    @click.stop="openRoleSetupDialog(true)"
                    :disabled="!selectedRoleId"
                  >
                    <v-icon small>mdi-pencil</v-icon>{{ $t("admin.editRole") }}
                  </a-btn>
                </template>
                <span>{{ $t("admin.editRole") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <a-btn
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                    color="primaryDark"
                    @click.stop="onDeleteRole()"
                    :disabled="!selectedRoleId"
                  >
                    <v-icon small>mdi-delete</v-icon
                    >{{ $t("admin.deleteRole") }}
                  </a-btn>
                </template>
                <span>{{ $t("admin.deleteRole") }}</span>
              </v-tooltip>
            </v-toolbar>
            <v-list class="pa-0 paler-bg">
              <v-list-item>
                <v-list-item-avatar tile size="45" color="neutralGray">
                  <v-icon large dark>mdi-text-account</v-icon>
                </v-list-item-avatar>

                <v-list-item-content v-if="selectedRole">
                  <v-list-item-title>
                    <h5>
                      {{
                        selectedRoleId && selectedRole.role
                          ? selectedRole.role
                          : ""
                      }}
                    </h5>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-divider></v-divider>
            <v-card-text
              class="paler-bg"
              v-if="selectedRole"
              style="background-color: var(--v-appBar-base)"
              >{{
                $t("admin.listOfPermissionsSetFor", {
                  selectedRole: selectedRole.role,
                })
              }}
            </v-card-text>
            <module-permission
              v-model="selectedRole.permissions"
              :disabled="true"
              :permissionsList="permissionsList"
            ></module-permission>
            <v-divider></v-divider>
          </v-card>
        </v-row>
      </v-card-text>

      <MessageSheet
        :showMessage="displayMessage"
        :message="message"
        :messageType="messageType"
        @close="displayMessage = false"
      ></MessageSheet>
      <ConfirmDlg ref="confirm" />
    </v-card>
  </v-container>
</template>
<script>
import MessageSheet from "@/components/MessageSheet.vue";
import customFunctions from "@/codeFiles/taskHelper.js";
import ConfirmDlg from "@/components/ConfirmDialog.vue";
import AddRoles from "./AddRoles.vue";
import RolesList from "./RolesList.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import RolePermission from "./RolePermission.vue";
import UserPermission from "./UserPermission.vue";
import _ from "lodash";
import ModulePermission from "./ModulePermission.vue";
import SignalRMixin from "../../mixin/SignalRMixin";
import ABtn from "../../wrapper-component/ABtn.vue";
import Loader from "@/components/Loader";
export default {
  name: "RoleManagement",
  mixins: [SignalRMixin],
  data() {
    return {
      tabRender: 0,
      roleTabIndex: 0,
      screenHeight: 0,
      selectedRoleId: null,
      page: 1,
      search: "",
      dialog: false,
      roles: [],
      Actions: [],
      disableMessage: false,
      displayMessage: false,
      message: "",
      messageType: "",
      valid: false,
      rules: [(v) => !!v || "This field is mandatory"],
      selected: {
        id: 0,
        roleTitle: "",
        permissions: [],
      },
      roleForm: {
        id: null,
        tenantid: sessionStorage.getItem("tenantId"),
        role: "",
        permissions: [],
        role_type: "general",
      },
      refRoleForm: {
        id: null,
        tenantid: sessionStorage.getItem("tenantId"),
        role: "",
        permissions: [],
        role_type: "general",
      },
      Role: "",
      Edit: false,
      formData: null,
    };
  },
  components: {
    MessageSheet,
    AddRoles,
    ConfirmDlg,
    RolesList,
    RolePermission,
    UserPermission,
    ModulePermission,
    ABtn,
    Loader,
  },
  computed: {
    ...mapState({
      roleList: (state) => state.admin.roleList,
      roleDetails: (state) => state.admin.roleDetails,
    }),
    ...mapGetters({
      masterSettingTypes: "tenant/masterSettingTypes",
    }),
    LoaderText() {
      return this.$t("LoaderText");
    },
    selectedRole() {
      return this.roleDetails;
    },
    saveDisabled(val) {
      return !this.valid;
    },
    roleListByType() {
      let roleType = "general";
      if (this.roleTabIndex !== 0) {
        roleType = "meeting_type";
      }
      return this.roleList.filter((r) => r.role_type === roleType);
    },
    filteredItems() {
      return _.orderBy(
        this.roleListByType.filter((item) => {
          if (!this.search) return this.roleList;
          return item.role.toLowerCase().includes(this.search.toLowerCase());
        })
      );
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    generalPermissions() {
      const permissions = this.masterSettingTypes("general_permissions");
      return [...permissions];
    },
    meetingTypePermissions() {
      const permissions = this.masterSettingTypes("meeting_type_permissions");
      return [...permissions];
    },
    permissionsList() {
      if (this.roleTabIndex === 0) {
        return this.generalPermissions;
      }
      return this.meetingTypePermissions;
    },
  },
  mounted,
  watch: {
    async selectedRoleId(id) {
      if (id) {
        await this.getRoleDetailsById(id);
      }
    },
  },
  methods: {
    ...mapActions({
      getRoleList: "admin/getRoleList",
      getRoleById: "admin/getRoleById",
      deleteRoleAction: "admin/deleteRole",
    }),
    onSuccess,
    onTabChange,
    async openRoleSetupDialog(isEdit) {
      try {
        const defaultPermission = this.permissionsList.filter(
          (p) => p.isDefault
        );
        if (isEdit && this.selectedRoleId) {
          this.Edit = true;
          const data = await this.getRoleById(this.selectedRoleId);
          this.formData = data;
          this.roleForm = _.cloneDeep(data);
        } else {
          this.Edit = false;
          this.roleForm = _.cloneDeep(this.refRoleForm);
          this.roleForm.permissions = defaultPermission.map((d) => d.id);
          if (this.roleTabIndex !== 0) {
            this.roleForm.role_type = "meeting_type";
          }
        }
        this.formData = _.cloneDeep(this.roleForm);
        this.dialog = true;
      } catch (error) {
        console.log(error, "role management");
      }
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    close() {
      this.dialog = false;
    },
    async onDeleteRole() {
      if (!this.selectedRoleId) {
        return;
      }
      if (
        await this.$refs.confirm.open(
          this.$t("admin.confirmRoleDeletion"),
          this.$t("admin.roleDeletionMessage")
        )
      ) {
        const roleId = _.cloneDeep(this.selectedRoleId);
        this.selectedRoleId = null;
        await this.deleteRoleAction(roleId)
          .then((response) => {
            if (response == "OK") {
              this.showMessageSheet(
                this.$t("admin.msgRoleDeleteSuccess"),
                "success"
              );
              if (document.getElementById("scroller-box")) {
                document.getElementById("scroller-box").scroll({
                  top: 0,
                  left: 0,
                  behavior: "smooth",
                });
              }
            }
          })
          .catch((error) => {
            this.selectedRoleId = roleId;
          });
      }
    },
    async getRoleDetailsById(id) {
      await this.getRoleById(id);
    },
    async DeleteRole() {
      this.displayMessage = false;
    },
    onResize() {
      this.screenHeight = window.innerHeight - 325;
    },
    async signalRInit() {
      try {
        let target = `admin_${this.selectedTenant}`;
        this.signalConnection.on(target, async (message) => {
          const result = JSON.parse(message);
          if (result) {
            // await this.$auth.loadPermissions(this.$auth.user.email);
            if (this.roleList.length && this.selectedRoleId) {
              await this.getRoleDetailsById(this.selectedRoleId);
            }
          }
        });
        if (
          this.signalConnection.connectionState.toLowerCase() === "disconnected"
        ) {
          this.signalConnection.start().catch();
        }
      } catch (error) {
        console.log(error, "Role management")
      }
    },
  },
};

function onTabChange() {
  if (this.roleListByType.length) {
    this.selectedRoleId = this.roleListByType[0].id;
  }
}

async function mounted() {
  if (this.roleListByType.length) {
    this.selectedRoleId = this.roleListByType[0].id;
  } else {
    this.selectedRoleId = null;
  }
  setTimeout(() => {
    this.tabRender++;
  }, 200);
  await this.signalRInit();
}

function onSuccess() {
  this.Edit
    ? this.showMessageSheet(this.$t("admin.msgRoleUpdateSuccess"), "success")
    : this.showMessageSheet(this.$t("admin.msgRoleCreateSuccess"), "success");
}
</script>
<style scoped>
::v-deep .v-pagination__item {
  height: 20px;
  font-size: 0.8rem;
  min-width: 20px !important;
}

::v-deep .v-pagination__navigation {
  width: 20px;
  height: 20px;
}

::v-deep .v-card__text {
  width: 100%;
  padding: 12px !important;
}

::v-deep .v-card__text {
  width: 100%;
  padding: 12px !important;
}

::v-deep .v-btn__content {
  text-transform: none;
  font-size: 0.875rem;
  font-weight: normal;
  font-family: unset;
}

/* default split bar color */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal {
  background: var(--v-pageHeader-lighten2);
  z-index: 1 !important;
  width: 1px !important;
  margin-left: 1px;
  margin-right: 1px;
}

.splitterContent
  /deep/
  .e-split-bar.e-split-bar-horizontal.e-resizable-split-bar::after {
  width: 4px !important;
}

/* split bar color in hover and active state */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal.e-split-bar-hover,
.e-splitter .e-split-bar.e-split-bar-horizontal.e-split-bar-active {
  background: var(--v-pageHeader-base);
}

/* default split bar resize handle color */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal .e-resize-handler {
  color: var(--v-pageHeader-base);
}

/* default split bar resize handle color in hover and active state */
::v-deep
  .e-splitter
  .e-split-bar.e-split-bar-horizontal.e-split-bar-hover
  .e-resize-handler,
.e-splitter
  .e-split-bar.e-split-bar-horizontal.e-split-bar-active
  .e-resize-handler {
  color: var(--v-pageHeader-base);
}

/* split bar arrows - circular border */
::v-deep
  .e-splitter
  .e-split-bar.e-split-bar-horizontal.e-split-bar-hover
  .e-navigate-arrow.e-arrow-left {
  background-color: var(--v-pageHeader-lighten2) !important;
  opacity: initial;
}

::v-deep
  .e-splitter
  .e-split-bar.e-split-bar-horizontal.e-split-bar-hover
  .e-navigate-arrow.e-arrow-right {
  background-color: var(--v-pageHeader-lighten2) !important;
  opacity: initial;
}

/* split bar arrows */

::v-deep
  .e-splitter
  .e-split-bar.e-split-bar-horizontal
  .e-navigate-arrow.e-arrow-right {
  background-color: var(--v-pageHeader-lighten3) !important;
  opacity: 0.2;
}
::v-deep .v-tabs > .v-tabs-bar {
  /* background-color: #1E1E1E; */
  background: transparent !important;
}

.user-list {
  /*height: 300px;*/ /* or any height you want */
  height: calc(100vh - 360px);
  overflow-y: auto;
  margin-left: 20px;
}
.a-tabs .v-tab--active {
  background: #dde3ee;
}
.paler-bg {
  background: #f5f5f5 !important;
}
.a-tabs /deep/ .v-slide-group__content {
  justify-content: right;
}
</style>